// Visible cards, not server-rendered cards, are the impression denominator.
(function () {
  var selector = '[data-track="forecast_editorial_article_click"]';
  var seen = new WeakSet();
  var observer;

  function track(link, eventName) {
    if (typeof window.gtag !== 'function') return false;
    try {
      var url = new URL(link.href, window.location.href);
      window.gtag('event', eventName, {
        article_path: url.pathname,
        article_topic: link.getAttribute('data-article-topic'),
        page_type: link.getAttribute('data-page-type'),
        place_id: link.getAttribute('data-place-id'),
        placement: link.getAttribute('data-placement') === 'city_hub_pilot' ? 'city_hub_pilot' : 'forecast_brief',
        transport_type: 'beacon'
      });
      return true;
    } catch (_) { return false; }
  }

  function impression(link) {
    if (!seen.has(link) && track(link, 'forecast_editorial_article_view')) seen.add(link);
  }

  function disconnect() {
    if (observer) observer.disconnect();
  }

  function start() {
    disconnect();
    if (document.documentElement.hasAttribute('data-turbolinks-preview')) return;
    // Do not fabricate impressions on browsers without visibility observation.
    if (!window.IntersectionObserver) return;
    observer = new window.IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (document.visibilityState !== 'hidden' && entry.isIntersecting && entry.intersectionRatio >= 0.5) {
          impression(entry.target);
          if (seen.has(entry.target)) observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.5 });
    document.querySelectorAll(selector).forEach(function (link) { observer.observe(link); });
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest(selector) : null;
    if (!link) return;
    // A click is also proof of exposure if the observer has not delivered yet.
    impression(link);
    track(link, 'forecast_editorial_article_click');
  });
  document.addEventListener('turbolinks:load', start);
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState !== 'hidden') start();
  });
  document.addEventListener('turbolinks:before-cache', disconnect);
})();
